import { X } from "lucide-react";
import {
  WILDLIFE_RESCUE_MODE_TITLE,
  WILDLIFE_RESCUE_INFO_INTRO,
  WILDLIFE_RESCUE_DISCLAIMER,
  WILDLIFE_RESCUE_ORDINANCES,
} from "@shared/wildlifeRescue";

interface Props {
  open: boolean;
  onClose: () => void;
}

export function WildlifeRescueInfoModal({ open, onClose }: Props) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-end sm:items-center justify-center"
      onClick={onClose}
      data-testid="modal-wildlife-info"
    >
      <div className="absolute inset-0 bg-black/40" />
      <div
        className="relative w-full max-w-lg max-h-[85%] bg-white rounded-t-2xl sm:rounded-2xl shadow-2xl overflow-hidden flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="pt-2 pb-1 flex justify-center sm:hidden">
          <div className="w-10 h-1 rounded-full bg-[var(--color-app-bg-tertiary)]" />
        </div>
        <div className="px-5 pt-3 pb-2 flex items-center justify-between">
          <h3
            className="text-lg font-bold text-[var(--color-app-text)]"
            data-testid="text-wildlife-info-title"
          >
            {WILDLIFE_RESCUE_MODE_TITLE}
          </h3>
          <button
            onClick={onClose}
            className="size-8 rounded-full hover:bg-[var(--color-app-bg-tertiary)] flex items-center justify-center"
            aria-label="Schließen"
            data-testid="button-wildlife-info-close"
          >
            <X size={18} className="text-[var(--color-app-text-secondary)]" />
          </button>
        </div>
        <div className="overflow-y-auto px-5 pb-5 space-y-4">
          <p className="text-sm text-[var(--color-app-text-secondary)]">
            {WILDLIFE_RESCUE_INFO_INTRO}
          </p>

          {WILDLIFE_RESCUE_ORDINANCES.map((ord) => (
            <div
              key={ord.id}
              className="rounded-xl border border-[var(--color-app-border)] bg-[var(--color-app-bg-secondary)] p-4"
              data-testid={`card-wildlife-ordinance-${ord.id}`}
            >
              <div className="text-[13px] font-bold text-brand-600">{ord.authority}</div>
              <div className="text-[15px] font-semibold text-[var(--color-app-text)] mt-0.5 mb-2">
                {ord.title}
              </div>
              <div className="text-[11px] font-bold uppercase tracking-wide text-[var(--color-app-text-secondary)]">
                Geltungsbereich
              </div>
              <p className="text-sm text-[var(--color-app-text)] mt-1 mb-2">{ord.scope}</p>
              <div className="text-[11px] font-bold uppercase tracking-wide text-[var(--color-app-text-secondary)]">
                Wichtige Auflagen
              </div>
              <ul className="text-sm text-[var(--color-app-text)] mt-1 list-disc pl-5 space-y-1">
                {ord.conditions.map((c, i) => (
                  <li key={i}>{c}</li>
                ))}
              </ul>
              <a
                href={ord.sourceUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block mt-3 text-sm font-semibold text-brand-600 hover:underline"
                data-testid={`link-wildlife-source-${ord.id}`}
              >
                Quelle: {ord.sourceLabel}
              </a>
            </div>
          ))}

          <p className="text-xs italic text-[var(--color-app-text-tertiary)]">
            {WILDLIFE_RESCUE_DISCLAIMER}
          </p>
        </div>
      </div>
    </div>
  );
}
